import React from 'react'
import { iOS, appButtonUrls } from '../../device'
import { averageRating, modified, reviewCount } from 'lifesum-shared/reviews'
import StarRating from '../StarRating/StarRating'
import useBreakpoints from 'js/hooks/useBreakpoints'
import useLocale from '../../hooks/useLocale'
import { appIcon } from 'js/imageSources'

type AggregateRatingIconProps = {
  href: string
}

const AggregateRatingIcon = ({ href }: AggregateRatingIconProps) => {
  const { MD, LG } = useBreakpoints()
  const size = LG ? '115px' : MD ? '100px' : '60px'

  return (
    <a
      href={href}
      className="mr-16 shrink-0 md:mr-24"
      style={{ height: size, width: size }}
    >
      <img
        itemProp="image"
        src={`${appIcon}?auto=format&w=200`}
        alt="Lifesum app icon"
        className="rounded-12 lg:rounded-20"
      />
    </a>
  )
}

function AggregateRating() {
  const { language } = useLocale()
  const generalURL = iOS ? appButtonUrls.apple : appButtonUrls.google

  return (
    <div className="o-width-limiter mb-32 text-center type-14">
      <div
        className="inline-flex rounded-16 border border-Border bg-Bg py-8 pl-8 pr-16 text-left shadow-elevated md:py-16 md:pl-16 md:pr-24 lg:rounded-24"
        itemScope
        itemType="http://schema.org/Product"
      >
        <AggregateRatingIcon href={generalURL} />
        <div className="my-auto">
          <h2 className="mb-4 type-17-demibold" itemProp="name">
            Lifesum App
          </h2>
          <div
            itemProp="aggregateRating"
            itemScope
            itemType="http://schema.org/AggregateRating"
          >
            <div className="mb-11 flex items-center">
              <StarRating rating={averageRating} />
              <span className="ml-4 mt-2">
                <span itemProp="ratingValue">{averageRating}</span>
                /5
              </span>
            </div>
            <p className="mb-2">
              Based on{' '}
              <span itemProp="reviewCount">
                {new Intl.NumberFormat(language).format(reviewCount)}
              </span>{' '}
              customer reviews.
            </p>
          </div>
          <p className="text-grey-dark">
            Last updated: {modified}. To leave a review, visit{' '}
            <a
              href="https://itunes.apple.com/app/id286906691?mt=8"
              className="text-beige-darker hover:text-beige-darkest"
            >
              App Store
            </a>{' '}
            or{' '}
            <a
              href="https://play.google.com/store/apps/details?id=com.sillens.shapeupclub"
              className="text-beige-darker hover:text-beige-darkest"
            >
              Google Play
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  )
}

export default AggregateRating
